module.exports = {
  /**
   * ランダムなIDを採番します。
   */
  randomNum: function () {
    var len = 10;
    var str = "ACDEFGHIJKLMNPQRSTUVWXYabcdefghijkmnprstuvwxyz34567";
    var strLen = str.length;
    var num = "";
    for (var i = 0; i < len; i++) {
      num += str[Math.floor(Math.random() * strLen)];
    }
    return num;
  },
  /**
   * エラーオブジェクトを生成し、プロパティをセットしてエラーをthrowします。
   * @param {String} errMsg
   * @param {String} statusCode
   * @param {String} customErrorCode
   */
  throwError: function (errMsg, statusCode, customErrorCode) {
    var errorCode = customErrorCode ? customErrorCode : this.randomNum();
    throw new Error(errorCode);
  }
}